import React, { useMemo, useState } from 'react'
import CommonCard from '../../../global/card'
import CommonSkeletonLoader from '../../../global/loading'
import { useGenericQuery } from '../../../../queries/use-generic-query';
import SOURCES from '../../../../utils/constants';
import { QUERY_KEYS } from '../../../../lib/query-constants';
import EnhancedCouponsList from './enhancedCouponsList';
import useDebounce from '../../../../utils/customHooks';
import { useLocation } from 'react-router-dom';
import CommonPagination from '../../../global/pagination';

const EnhancedCoupons = () => {
    const { DEFAULT_RECORDS_LISTING } = SOURCES;
    const [couponsViewType, setCouponsViewType] = useState(() => {
        return localStorage.getItem("couponsViewType") || SOURCES.DEFAULT_VIEW_TYPE;
    });
    const [searchCoupons, setSearchCoupons] = useState("")
    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });
    const [editCoupon, setEditCoupon] = useState({
        show: false,
        isEditable: false,
        isEdit: false,
        id: null
    })


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(searchParams.get("page") || 1, 10);
    const limitFromQuery = parseInt(
        searchParams.get("limit") || SOURCES.DEFAULT_RECORDS_LISTING,
        24
    );
    const offsetFromQuery = parseInt(searchParams.get("offset") || "0", 10);

    const [pagination, setPagination] = useState({
        offset: offsetFromQuery,
        limit: limitFromQuery,
        page: pageFromQuery,
    });

    const keyParams = {
        offset: pagination.offset,
        limit: pagination.limit,
        sortBy: sort.sortType,
        sortOrder: sort.sortOrder
    }
    const queryKey = QUERY_KEYS.coupons.lists(keyParams)
    const debouncedSearchTerm = useDebounce(searchCoupons, 500);

    const { data, isLoading, isFetching, refetch } = useGenericQuery(
        {
            queryKey,
            queryParams: keyParams,
            endpoint: "coupon",
            onError: () => { },
            onSuccess: () => { }
        }
    )
    const { data: searchData, isInitialLoading: searchDataLoading } = useGenericQuery(
        {
            queryKey: QUERY_KEYS.coupons.lists({ q: debouncedSearchTerm }),
            queryParams: { q: debouncedSearchTerm },
            endpoint: "coupon/search",
            onError: () => { },
            onSuccess: () => { },
            enabled: !!debouncedSearchTerm.trim("")
        }
    )

    const getFinalData = useMemo(() => {
        if (searchData?.results && Array.isArray(searchData?.results)) return searchData?.results
        if (data?.results && Array.isArray(data.results)) return data.results
        return []

    }, [data, searchData])

    return (
        <CommonCard isSearch={{
            show: true,
            searchInput: searchCoupons,
            placeholder: "Search coupons...",
            setSearchInput: setSearchCoupons
        }}
            isListGridView={{
                show: true,
                viewType: couponsViewType,
                setViewType: setCouponsViewType,
                viewFor: "couponsViewType"
            }}
            isLoading={{
                show: isLoading || searchDataLoading,
                loaderCmp: (
                    <CommonSkeletonLoader
                        rows={9}
                        type={couponsViewType === "GRID" ? "card" : "table"}
                        tableLength={7}
                    />
                ),
            }}

            isCreateButton={{
                show: true,
                text: "Add Coupon",
                onclick: () => setEditCoupon({
                    show: true,
                    isEditable: false,
                    isEdit: false,
                    id: null
                }),
            }}
            className={(!isLoading && isFetching) && "opacity-50"}
        >
            <EnhancedCouponsList
                coupons={getFinalData}
                sort={sort}
                setSort={setSort}
                getCoupons={refetch}
                isLoading={isLoading || searchDataLoading}
                viewType={couponsViewType}
                editCoupon={editCoupon}
                setEditCoupon={setEditCoupon}
                keyParams={keyParams}
            />

            {(Array.isArray(data) && data.length > 0 && !searchCoupons) && (
                <CommonPagination
                    currentPage={pagination.page}
                    defaultLimit={pagination.limit}
                    totalRecords={data?.count}
                    setCurrentPage={setPagination}
                    // title={``}
                    activePageRecords={Array.isArray(data) ? data?.length : 0}
                    paginationFor="Coupons"
                    className="mt-4"
                />
            )}
        </CommonCard>
    )
}

export default EnhancedCoupons
